import React, { FC } from 'react';
import { EditableDistanceFields } from '../../../../common/EditableDistanceFields/EditableDistanceFields';
import { inchesToFeetAndInches } from '../../../../../contrib/Utils/inchesToFeetAndInches';
import { IHoleResult } from '../../../../../store/admin/holeResults/store';

interface IProps {
  holeResult: IHoleResult;
}

export const ExpandableCTPTableSubRow: FC<IProps> = props => {
  const { holeResult } = props;

  const processedDistance = inchesToFeetAndInches(holeResult.pinDistance);

  const { feet, inches } = processedDistance || { feet: 0, inches: 0 };

  return feet > 0 && inches > 0 ? (
    <div className="eliminated-player-row ctp">
      {`${holeResult.userFirstName[0]}. ${holeResult.userLastName}`}

      <EditableDistanceFields feet={feet} inches={inches} />
    </div>
  ) : (
    <></>
  );
};
